import React from "react";

import { HubButton } from "../../components";

import {
  StyledHubButtonGroup,
  StyledTitledSubStack,
  StyledTitleStack,
} from "./styles";

const VIEW_MODES = [
  { id: 0, label: "Board", icon: "CreditCard" },
  { id: 1, label: "Table", icon: "List" },
];

const QuotesBar = ({ viewMode = 0, setViewMode = () => {} }) => {
  return (
    <StyledTitleStack>
      <StyledTitledSubStack disableYPadding>
        <StyledHubButtonGroup
          buttons={VIEW_MODES}
          selected={viewMode}
          setSelected={setViewMode}
          buttonProps={{ variant: "outlined" }}
          allowNeutral
        />
      </StyledTitledSubStack>
      <StyledTitledSubStack>
        <HubButton
          label="Create Quote"
          icon="Settings"
          variant="contained"
          color="neutral"
          size="xsmall"
          iconProps={{ size: "10px" }}
          page="/quotes"
        />
      </StyledTitledSubStack>
    </StyledTitleStack>
  );
};

export default QuotesBar;
